{{#if isPipelined}}
virtual task wait_for_request_grant();
  {{ requestGrantsVariable.identifier }}.get(1);
endtask
{{/if}}
